import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Loader2, LogOut, Clock } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/ruempeltaxi-logo.png";

export default function EmployeeLayout() {
  const { user, checked, logout } = useAuth();
  const navigate = useNavigate();

  if (!checked || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-black">
        <Loader2 className="h-8 w-8 animate-spin text-yellow" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-light-gray" data-testid="employee-layout">
      <Helmet>
        <title>Mitarbeiterbereich | Rümpeltaxi</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <header className="border-b border-dark-gray bg-brand-black">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Rümpeltaxi" className="h-8 w-auto" />
            <span className="hidden items-center gap-2 border-l border-dark-gray pl-3 font-heading text-sm font-semibold text-light-gray/70 sm:flex">
              <Clock className="h-4 w-4 text-yellow" /> Stundennachweis
            </span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-light-gray/70" data-testid="employee-name">{user.name}</span>
            <button
              onClick={onLogout}
              className="inline-flex items-center gap-2 rounded-sm px-3 py-2 font-heading text-sm font-semibold text-light-gray/70 transition-colors hover:bg-dark-gray hover:text-white"
              data-testid="employee-logout"
            >
              <LogOut className="h-4 w-4" /> Abmelden
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 md:py-10">
        <Outlet />
      </main>
    </div>
  );
}
